var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoadMapPageCardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9985 13.4332V19.1941C20.9985 20.1393 20.2325 20.8336 19.3187 20.8739C18.4116 20.9143 17.6388 20.0721 17.6388 19.1941V17.0931V7.97734V6.27284L8.82288 15.0888L4.62326 19.2884L2.8583 21.0533L2.85813 21.0535C2.19965 21.712 1.1559 21.6672 0.483945 21.0535C-0.18354 20.4443 -0.138701 19.302 0.483945 18.6793L0.510822 18.6525C0.976716 18.1672 1.45851 17.6918 1.94031 17.2165C2.18121 16.9788 2.42212 16.7412 2.66104 16.5022L7.05104 12.1122L12.1623 7.00098L15.2669 3.89635H8.10193H2.34107C1.40036 3.89635 0.701521 3.13036 0.661205 2.21649C0.620896 1.30938 1.46309 0.536621 2.34107 0.536621H4.44203H13.5578H19.3187C19.7768 0.536621 20.1977 0.730808 20.5037 1.03876C20.6967 1.21581 20.8298 1.43757 20.9063 1.67836C20.966 1.84831 20.9985 2.02954 20.9985 2.21649V4.31745V13.4332Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadMapPageCardIcon);
export default __webpack_public_path__ + "static/media/roadMapPageCardIcon.deb7002e.svg";
export { ForwardRef as ReactComponent };